export { default } from './DotsHorizontal'
